import { render, staticRenderFns } from "./HangupCallButton.vue?vue&type=template&id=5318129a&scoped=true&"
import script from "./HangupCallButton.vue?vue&type=script&lang=js&"
export * from "./HangupCallButton.vue?vue&type=script&lang=js&"
import style0 from "./HangupCallButton.vue?vue&type=style&index=0&id=5318129a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5318129a",
  null
  
)

export default component.exports